import Chip from '@mui/material/Chip';
import React from 'react';

const OrderStatusRenderer = ({ value, type = 'po' }) => {
  if (!value) {
    return <Chip size="small" label="-" variant="outlined" />;
  }

  const status = value.toLowerCase().trim();
  let label = value;
  let color = 'secondary';

  /* ================= PR ================= */
  if (type === 'pr') {
    switch (status) {
      case 'draft':
        label = 'Unsent';
        color = 'info';
        break;
      case 'published':
        label = 'Sent';
        color = 'warning';
        break;
      case 'approved':
        label = 'Approved';
        color = 'success';
        break;
      case 'rejected':
        label = 'Rejected';
        color = 'error';
        break;
      default:
        break;
    }
  }

  /* ================= PO ================= */
  if (type === 'po') {
    switch (status) {
      case 'draft':
        label = 'Unsent';
        color = 'info';
        break;
      case 'sent':
        label = 'Sent';
        color = 'warning';
        break;
      case 'accepted':
        label = 'Accepted';
        color = 'primary';
        break;
      case 'declined':
        label = 'Declined';
        color = 'error';
        break;
      case 'approved':
        label = 'Approved';
        color = 'success';
        break;
      default:
        break;
    }
  }

  /* ================= ONGOING ================= */
  if (type === 'ongoing') {
    switch (status) {
      case 'draft':
        label = 'In Process';
        color = 'warning';
        break;
      case 'void':
      case 'cancelled':
        label = 'Cancelled';
        color = 'error';
        break;
      case 'open':
        label = 'Packed';
        color = 'warning';
        break;
      case 'closed':
        label = 'Completed';
        color = 'success';
        break;
      default:
        break;
    }
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <Chip
        size="small"
        label={label}
        color={color}
        variant={ 'outlined'}
      />
    </div>
  );
};

export default OrderStatusRenderer;
